module.exports = __webpack_public_path__ + "img/ic_logo_highfive@2x.4334713b.png";